/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Text } from 'components/Text';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { Content, LayoutCircle, Section, Spacer } from './styles';

const Subtitle = (props) => {
  const history = useHistory();
  const loading = useContext(GlobalLoaderContext);
  const fitinsur = new FitinsurAPI();
  const authContext = useContext(GlobalAuthContext);
  const mc = new MessageCenter();

  const checkOperationRoute = (idOperation, idProduct, idDomainStatusDoc) => {
    fitinsur.setAuthToken(authContext.token);
    console.log(idOperation)
    loading.start();

    fitinsur.requestQuoteEditNavigation(idOperation).then(x => x.json()).then(res => {
      if (res.ret_code != 200) {
        mc.error(res.ret_msg_details);
        return;
      }
      /* mc.error(res) */
      let route;
      const idOperationParent = res.ret_value.idOperationParent;
      switch (res.ret_value.idNavigation) {
        case 1:
          route = `/edit-enquirity/${idProduct}/${idOperation}${idOperationParent ? `/${idOperationParent}` : ""}`;
          break;
        case 2:
          route = `/edit-enquirity/${idProduct}/${idOperation}${idOperationParent ? `/${idOperationParent}` : ""}`;
          break;
        case 3:
          route = `/broking/approval-nbi/${idOperation}`;
          break;
        case 4:
          if (idProduct == "16") {
            route = `/broking/select-markets/${idOperation}/${idProduct}`;
          } else {
            route = `/broking/select-markets/${idOperation}`;
          }
          break;
        case 5:
          route = `/broking/contacts-selection/${idOperation}`;
          break;
        case 6:
          route = `/broking/nbi-request/${idOperation}`;
          break;
        case 7:
          route = `/broking/send-nbi-request/${idOperation}`;
          break;
        case 8:
          route = `/broking/market-selection/${idOperation}`;
          break;
        case 9:
          route = `/broking/document-nbi-status/${idOperation}`;
          break;
        case 10:
          route = `/broking/approval-nbi-cv/${idOperation}`;
          break;
        case 11:
          route = `/broking/nbi-request-cv/${idOperation}`;
          break;
        case 12:
          route = `/broking/market-composition/${idOperation}`;
          break;
        case 13:
          route = `/broking/policy-pack-approval/${idOperation}`;
          break;
        case 14:
          route = `/broking/approval-policy-pack/${idOperation}`;
          break;
        case 15:
          route = `/broking/send-policy-pack-client/${idOperation}`;
          break;
        case 16:
          route = `/broking/send-approval-pack/${idOperation}`;
          break;
        case 17: //result.ret_value = {idNavigation: 17, dscNavigation: "Order to Bind Sent"};
          route = `/broking/send-order-to-bind/${idOperation}`;
          break;
        case 18: //result.ret_value = {idNavigation: 18, dscNavigation: "Order to Bind Approved"};
          route = `/broking/order-to-bind/${idOperation}`;
          break;
        case 19: //result.ret_value = {idNavigation: 19, dscNavigation: "Order to Bind Rejected"};
          route = `/broking/order-to-bind/${idOperation}`;
          break;
        case 20: //result.ret_value = {idNavigation: 20, dscNavigation: "Stamp Requested"};
          route = `/broking/stamps-status-list/${idOperation}`;
          break;
        case 21: //result.ret_value = {idNavigation: 21, dscNavigation: "Stamp Requested"};
          route = `/broking/payment-pack-send-approval/${idOperation}`;
          break;
        case 22: //result.ret_value = {idNavigation: 22, dscNavigation: "Stamp Requested"};
          route = `/broking/payment-pack-send-client-insurer/${idOperation}`;
          break;
        case 23: //result.ret_value = {idNavigation: 23, dscNavigation: "Stamp Requested"};
          route = `/broking/payment-pack-approval/${idOperation}`;
          break;
        case 24:
          route = `/broking/send-nbi-cv/${idOperation}`;
          break;
        case 25:
          route = `/edit-master-policy/${idProduct}/${idOperation}`;
          break;
        case 26:
          route = `/broking/send-approval-pack-declaration/${idOperation}`;
          break;
        case 99:
          route = `/edit-enquirity/${idProduct}/${idOperation}${idOperationParent ? `/${idOperationParent}` : ""}`;
          break;

      }
      if (route) {
        loading.stop();
        history.push(route, res.ret_value.idNavigation == 99 ? { disabled: true, idProduct: idProduct } : { status: idDomainStatusDoc, idProduct: idProduct });
      } else {
        mc.error('NAVIGATION NOT DEFINED');
        loading.stop();
      }
    }).catch((e) => loading.stop());
  }
  return (
    <Content>
      <Section>
        <LayoutCircle onClick={() => {
          if (props.stage != 1 && props.info) {
            if ((!props.info.idOperation || !props.info.idProduct)) return;
            history.push(`/edit-enquirity/${props.info.idProduct}/${props.info.idOperation}`, { disabled: true });
          }
        }} isActive={props.stage === 1}>1 </LayoutCircle>
        <Text className="d-none d-sm-block" spaceLeft={true} >ENQUIRY</Text>
      </Section>
      <Spacer className="d-sm-none"></Spacer>
      <Section>
        <LayoutCircle onClick={() => {
          if (props.stage != 2 && props.info) {
            if ((!props.info.idOperation || !props.info.idProduct)) return;
            checkOperationRoute(props.info.idOperation, props.info.idProduct);
          }
        }}
          isActive={props.stage === 2}>2</LayoutCircle>
        <Text className="d-none d-sm-block" spaceLeft={true}>BROKING</Text>
      </Section>
      <Spacer className="d-sm-none"></Spacer>
      <Section>
        <LayoutCircle isActive={props.stage === 3}>3</LayoutCircle>
        <Text className="d-none d-sm-block" spaceLeft={true}>BINDING</Text>
      </Section>
    </Content>
  )
}
export default Subtitle;